import startCase from "lodash/startCase";
import lowerCase from "lodash/lowerCase";

export const toTitleCase = (str: string) => {
  return startCase(lowerCase(str));
};
